/**
 * Handles the change in port for the offload/loading area.
 */

var VRC = VRC || {};

VRC.BulkToolbarView = (function(){

  var _queries = {
    container : '#bulk-toolbar'
  };

  var init = function(){
    render();
  };

  var attachEvents = function($html){
      attachFetchManifest($html);
      attachChange($html);
  };

  var attachFetchManifest = function($html){
    var $btn = $html.find('.bulk-toolbar__fetch');

    $btn.unbind('click').click(function(e){
      var port = getSelectedPort($html);
      loadBulkCargoRequest(port);
    });
  };

  var getLoadingHeader = function(){
    return $('.bulk-loading-area').find('h3:first-of-type');
  };

  var getOffloadingHeader = function(){
    return $('.bulk-offloading-area').find('h3:first-of-type');
  };

  var setHeaders = function($selectBox){
    $selectBox = $selectBox || getSelectBox();
    var name = $selectBox.children('option:selected').text();

    var $loadingHeader = getLoadingHeader();
    var $offloadHeader = getOffloadingHeader();

    $loadingHeader.text('Loading area: ' + name);
    $offloadHeader.text('Offloading area: ' + name);
  };

  var attachChange = function($html){

    var $selectBox = getSelectBox($html);

    $selectBox.unbind('change').change(function(){

      VRC.BulkCargoRequestManager.clear();
      VRC.BulkLoadingAreaView.render({});
      VRC.BulkOffloadAraeView.init();
      setHeaders();
    });

    $selectBox.selectize(VRC.Utils.Selectize.getConfig());

  };

  var loadBulkCargoRequest = function(portId){

    VRC.BulkLoadingAreaView.showLoading();

    var loadBulkCargoRequest = VRC.BulkCargoRequestManager.loadOnline(portId);
    loadBulkCargoRequest.done(function(bulkRequests){
      VRC.BulkLoadingAreaView.init(bulkRequests);
      setHeaders();
    });
  };

   var getSelectBox = function($html){
     $html = $html || $(_queries.container);
     return $html.find('.bulk-toolbar__port-selector');
   };

  var getSelectedPort = function($html){
     $html = $html || $(_queries.container);
    var $selectBox = getSelectBox($html);
    var value = $selectBox.children('option:selected').val();

    return parseInt(value);
  };

  var render = function(){
    var $container  = $(_queries.container);

    var $html = $(WELL.Handlebars.VRC.bulk_toolbar(VRC.MasterDataService.getGroupedPorts()));

    attachEvents($html);

    $container.html($html);
    setHeaders();
  };

  return {
    init : init,
    getSelectedPort : getSelectedPort
  }
})();
